// extracted by mini-css-extract-plugin
export default {"root":"password-description__root","description":"password-description__description"};